import { c as _c } from "react/compiler-runtime";
import { safeJsonStringify } from '@/utils/strings';
import type { DependencyList, EffectCallback } from 'react';
import { useEffect } from 'react';

/**
 * A wrapper around React's useEffect but with reliable deps comparisons.
 * You can use Objects/Sets/Arrays, and they will be serialized for the comparison to determine changes
 */
export const useEffectDeps = (effect, deps) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== deps) {
    t0 = deps.map(safeJsonStringify);
    $[0] = deps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(effect, t0);
};